import * as yup from "yup";

export interface FormData {
  customerName: string;
  phoneNumber: string;
}

yup.setLocale({
  mixed: {
    required: "Dette felt er obligatorisk",
  },
  string: {
    min: "Ugyldigt telefonnummer",
  },
});

export const validationSchema = () => {
  return yup.object().shape({
    customerName: yup.string().required().trim(),
    phoneNumber: yup.string().required().trim().strict().min(6),
  });
};

export const to = (body: any) => {
  // Not used for this form
};

export default validationSchema;
